<template>
  <div class="__center">
    <div class="mgt40 ft30px"><b>신고대리 위탁 요청이 완료 되었습니다.</b></div>
    <div class="mgt20">
      <span class="info1">
        회계법인과 노무법인의 신고대리위탁계약은 최대 1주일이 소요됩니다.
        <br/>(지연 사유 : 이전 업체 미해지, 공단별 업무 지연 등)
      </span>
    </div>
    <div class="mgt20">
      <span class="info1">신고대리 위탁 상태 확인은 포털 우측 상단 > 시설/서비스 > 서비스 신청 내역에서 확인 가능합니다.</span>
    </div>
    <div class="mgt20">
      <span class="info1">신고대리 위탁이 진행되는 동안 아래의 버튼을 클릭하여 기초 세팅을 진행해 주시기 바랍니다.</span>
    </div>
    <div class="layer-btn">
      <btn :txt="'다음에 하기'"
           :color="'white'"
           @click="btnCancl_click"/>
      <btn :txt="'기초 세팅 하러 가기'"
           :color="'purple'"
           @click="btnEryyStpRqt_click"/>
    </div>
  </div>
</template>

<script setup>
import {defineEmits, defineProps} from "vue";
import {getStore, getUtils} from "@/utils/import";
const {$loading} = getStore();
const {$axios, $cmmn, $popup, $alert} = getUtils();

import SeroiSvcWait from "@/views/svc/seroi-svc-wait.vue";

const props = defineProps({
  fcltySn: Number
});

const emits = defineEmits(['close']);

const btnCancl_click = () => {
  emits('close');
};

const getFcltySvcUseDlByFcltySnSvcId = async (svcId, fcltySn) => {
  const params = {svcId, fcltySn};
  const {data} = await $axios.get('/api/svc/fclty-svc-use-dl/by-fclty-sn-svc-id', {params});
  return data;
};

const getFcltyStmnAgncyCnsgDlByFcltySn = async (fcltySn) => {
  const params = {fcltySn};
  const {data} = await $axios.get('/api/svc/fclty-stmn-agncy-cnsg-dl/by-fclty-sn', {params});
  return data;
};

const btnEryyStpRqt_click = async () => {
  try {
    $loading.on();

    const fcltySn = props.fcltySn;

    const svcId = $cmmn.svc.getSeroiSvcId();
    const svcUseDl = await getFcltySvcUseDlByFcltySnSvcId(svcId, fcltySn);
    const isSvcStpg = svcUseDl.svcStpgAt == 'Y';

    if (isSvcStpg) {
      await $alert('서비스 중지 상태입니다.');
      return false;
    }

    const stmnAncyCnsgDl = await getFcltyStmnAgncyCnsgDlByFcltySn(fcltySn);
    const stmnAgncyCnsgStcd = stmnAncyCnsgDl.stmnAgncyCnsgStcd;

    if (stmnAgncyCnsgStcd != '100') {
      await $axios.post('/api/cmmn/mber-session/fclty-sn', {fcltySn});

      const url = '/hr/views';
      const hrWindow = window.open('', 'seroi-hr');
      const isExist = hrWindow.location.href != 'about:blank' && !hrWindow.closed;

      hrWindow.location.href = url;

      if (isExist) hrWindow.focus();

      emits('compt');
      emits('close');
    } else {
      const popupOpts = {
        header: '세로이 서비스 신청 대기',
        contentStyle: {
          'width': '770px',
          'max-height': '660px',
        }
      };

      const props = { fcltySn };

      $popup.show(SeroiSvcWait, popupOpts, props);
    }
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
};
</script>

<style scoped>

</style>
